"use strict";

// import 'config/error-tracking';
import "@/config/axios.js";
import POLYESTER from "@/polyester.js";

POLYESTER.init();
